import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { ColumnLabelsFragment, ColumnLineageLabelsQuery, UpstreamColumnLabelsFragment } from '../../../../../../../gen-src/queries';
import { FeatureFlagsContext } from '../../../featureFlags/FeatureFlagsContext';
import { useContextWithOverride } from '../HookContext';
import { UseLabelsResultWithExecuteFunction, UseLabelsResult } from '../useRenderLabelsTypes';
import { GetContentLineageLabelsLazyQueryParams, convertLabelsFragmentIntoRenderProps } from './lazyQueryHelper';


export function useColumnLineageLabelsLazyQuery({ item, controls, includeParented, includeUpstream, contextOverrides, document }: GetContentLineageLabelsLazyQueryParams): UseLabelsResultWithExecuteFunction {
  const { customSensitivityLabelsEnabled } = useContextWithOverride(FeatureFlagsContext, contextOverrides?.featureFlags);

  const [fire, { loading, error, data }] = useLazyQuery<ColumnLineageLabelsQuery>(document);
  const invoke = React.useCallback(() => { void fire({ variables: { id: item.contentId ?? null, customSensitivityLabelsEnabled } }) }, [fire, item, customSensitivityLabelsEnabled]);

  const hasUpstreamColumns = (column: UpstreamColumnLabelsFragment): column is UpstreamColumnLabelsFragment => column.upstreamColumns !== undefined;
  const exists = (column: ColumnLabelsFragment): column is ColumnLabelsFragment => !!column;

  const upstreamLabels = data?.items.filter(hasUpstreamColumns).flatMap(t => t.upstreamColumns).filter(exists).flatMap(t => t.labels);

  const result: UseLabelsResult = { loading, error, ...convertLabelsFragmentIntoRenderProps({ upstreamLabels, item, controls, includeParented, includeUpstream }) };
  return [invoke, result]
}
